<template>
    <a-modal
    centered
    :title="title"
    :width="600"
    :visible="visible"
    :maskClosable="false"
    :destroyOnClose="true"
    :bodyStyle="{padding: '16px 24px'}"
    :confirmLoading="confirmLoading"
    :closable="source !== 'setNew'"
    :keyboard="source == 'setNew'"
    @cancel="close"
    >
        <div slot="footer">
            <a-button v-show="source !== 'setNew'" @click="close">取消</a-button>
            <a-button type="primary" @click="confirm">确定</a-button>
        </div>
        <div>
            <div class="mb24 text-color-45">请设置新密码，需包含大小写英文、特殊符号、数字中的任意两类，长度需6～20字符</div>
            <a-form :form="form">
                <a-form-item
                    label="原密码"
                    :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 18 }"
                    v-show="source !== 'setNew'"
                >
                    <a-input
                        type="password"
                        v-decorator="['oldPassword', {rules: [{ required: true, message: '请输入' }]}]"
                        placeholder="请输入原密码"
                    />
                </a-form-item>
                <a-form-item
                    label="新密码"
                    :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 18 }"
                >
                    <a-input
                        type="password"
                        v-decorator="['newPassword', {validateFirst: true, rules: [{ required: true, message: '请输入' }, {min: 6, message: '密码需要6位或以上'}, {max: 20, message: '密码需要20位或以下'}, customValidator()]}]"
                        placeholder="请输入新密码"
                    />
                </a-form-item>
                <a-form-item
                    label="确认密码"
                    :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 18 }"
                >
                    <a-input
                        type="password"
                        v-decorator="['newPassword2', {validateFirst: true, rules: [{ required: true, message: '请输入' }, customValidator2()]}]"
                        placeholder="请再次输入新密码"
                    />
                </a-form-item>
            </a-form>
        </div>
    </a-modal>
</template>
<script>
export default {
    name: "password",
    props: {

    },
    data() {
        return {
            title: '修改密码',
            visible: false,
            confirmLoading: false,
            source: 'modify'
        };
    },
    computed: {},
    methods: {
        open(source) {
            /**
             * @source setNew默认密码设置新密码 modify更改密码
             */
            if (source) {
                this.source = source;
                if (source === 'setNew') {
                    this.title = '设置新密码';
                    setTimeout(() => {
                        this.form.setFieldsValue({oldPassword: '3e7w8dps'});
                    }, 300);
                }
            }
            this.visible = true;
        },
        close() {
            this.visible = false;
            setTimeout(() => {
                this.title = '修改密码';
                this.source = 'modify';
                this.confirmLoading = false;
            }, 300);
        },
        confirm() {
            this.handleSubmit();
        },
        customValidator() {
            return ({validator: (rule, value, callback) => {
                let simplePasswordReg = new RegExp('123456');
                let accountReg = new RegExp(sessionStorage.getItem('account'));
                let userNameReg = new RegExp(sessionStorage.getItem('username'));
                let userPhoneReg = new RegExp(sessionStorage.getItem('phone'));
                let passwordReg = /((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z])).{6,20}/;
                let oldPassword = this.form.getFieldValue('oldPassword');
                if (simplePasswordReg.test(value)) {
                    callback('密码不得包含123456');
                }
                if (accountReg.test(value)) {
                    callback('密码不得与账户名称相同');
                }
                if (userNameReg.test(value)) {
                    callback('密码不得与用户名称相同');
                }
                if (userPhoneReg.test(value)) {
                    callback('密码不得与用户手机号相同');
                }
                if (!passwordReg.test(value)) {
                    callback('密码需要包含大小写英文、特殊符号、数字中的任意两类');
                }
                if (oldPassword === value) {
                    callback('新旧密码不得相同，请重新输入');
                }
                callback();
            }});
        },
        customValidator2() {
            return ({validator: (rule, value, callback) => {
                    let newPassword = this.form.getFieldValue('newPassword');
                    let newPassword2 = this.form.getFieldValue('newPassword2');
                    if (newPassword !== newPassword2) {
                        callback('确认密码与新密码不一致');
                    }
                    callback();
                }})
        },

        handleSubmit() {
            this.form.validateFields({force: true},(errors,values) => {
                if (!errors) {
                    this.confirmLoading = true;
                    this.$api.jurisdiction.password({
                        query: {
                            newPass: values.newPassword,
                            oldPass: values.oldPassword
                        }
                    }).then(res => {
                        this.confirmLoading = false;
                        this.$message.success("密码修改成功,请重新登录！",1);
                        this.close();
                        setTimeout(() => {
                            this.$router.push({name: 'login'});
                        }, 500);
                    }).catch(err =>{
                        this.confirmLoading = false;
                    });
                }
            })

        }
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
    },
    created() {},
    mounted() {}
}
</script>
<style rel="stylesheet/scss" lang="scss">
</style>
